/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** An experiment evaluated during a seller application. */
export type SellerApplicationExperiment =
  /** Whether the seller questionnaire opens in the dashboard or the standalone questionnaire. */
  | 'DASHBOARD_SELLER_QUESTIONNAIRE'
  /** The onboarding experience that shows every home-detail field on one editable page. */
  | 'HOME_DETAILS_LIVE_FORM'
  /** The account-page experience that offers a magic-link as the primary sign-in action for returning password customers. */
  | 'MAGIC_LINK_PRIMARY_CTA'
  /** The mortgage quote-interest experience evaluated during seller onboarding. */
  | 'MORTGAGE_QUOTE_INTEREST'
  /** The Acquisition Q4 experiment. control keeps current onboarding and the current preliminary offer page. onboarding_zero_revamped_prelim uses Onboarding Zero and the revamped preliminary offer page. onboarding_zero_only uses Onboarding Zero and the current preliminary offer page. revamped_prelim_only keeps current onboarding and uses the revamped preliminary offer page. */
  | 'ONBOARDING_ZERO'
  /** The account-page save-progress experience evaluated during seller onboarding. */
  | 'SAVE_PROGRESS_UI';

/** Details for evaluating an experiment for a seller application. */
export type SellerApplicationExperimentVariantEvaluateInput = {
  /** Seller application that supplies the identity required by the experiment. */
  applicationId: Types.Scalars['UUID']['input'];
  /** Seller application experiment to evaluate. */
  experiment: SellerApplicationExperiment;
};

export type SellerLeadCakeVariantEvaluateMutationVariables = Exact<{
  input: Types.SellerApplicationExperimentVariantEvaluateInput;
}>;


export type SellerLeadCakeVariantEvaluateMutation = { sellerApplicationExperimentVariantEvaluate:
    | { __typename: 'InvalidInputError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
    | { __typename: 'NotFoundError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
    | { __typename: 'SellerApplicationExperimentVariantEvaluatePayload', assignment: { value: Types.Scalars['String']['output'] | null } }
    | { __typename: 'UnauthorizedError', code: Types.Scalars['String']['output'], message: Types.Scalars['String']['output'] }
   };

export type SellerLeadCakeVariantQueryVariables = Exact<{
  applicationId: Types.Scalars['UUID']['input'];
}>;


export type SellerLeadCakeVariantQuery = { seller: { application: { experience: { experimentVariant: { value: Types.Scalars['String']['output'] | null } | null } } | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const SellerLeadCakeVariantEvaluateDocument = /*#__PURE__*/ new TypedDocumentString(`
    mutation SellerLeadCakeVariantEvaluate($input: SellerApplicationExperimentVariantEvaluateInput!) {
  sellerApplicationExperimentVariantEvaluate(input: $input) {
    __typename
    ... on SellerApplicationExperimentVariantEvaluatePayload {
      assignment {
        value
      }
    }
    ... on Error {
      code
      message
    }
  }
}
    `) as unknown as TypedDocumentString<SellerLeadCakeVariantEvaluateMutation, SellerLeadCakeVariantEvaluateMutationVariables>;
export const SellerLeadCakeVariantDocument = /*#__PURE__*/ new TypedDocumentString(`
    query SellerLeadCakeVariant($applicationId: UUID!) {
  seller {
    application(id: $applicationId) {
      experience {
        experimentVariant(experiment: DASHBOARD_SELLER_QUESTIONNAIRE) {
          value
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SellerLeadCakeVariantQuery, SellerLeadCakeVariantQueryVariables>;